import * as React from 'react';
import { Link } from '../../../Link';
import { mergeStyles } from '@cian/utils';
import styles from './MediaBanner.css';
import { Marquee } from '../../../Marquee';

export interface IMediaBannerProps {
  url?: string;
  logoImageUrl?: string;
  substrateNotNeeded?: string;
  name?: string;
  actionText?: string;
  phone?: string;
  buttonText?: string;
  info?: string;
  note?: string;
  onLinkClick?(): void;
}

export const MediaBanner: React.FC<IMediaBannerProps> = ({
  logoImageUrl,
  name,
  actionText,
  phone,
  url,
  buttonText = 'Узнать цены',
  info,
  substrateNotNeeded,
  onLinkClick,
  note,
}) => {
  return logoImageUrl ? (
    <>
      <div {...mergeStyles(styles['c-filters-brand'])}>
        <div className={styles['c-filters-brand-info']}>
          <a
            className={styles['c-filters-brand-flag']}
            href={url}
            target="_blank"
            role="img"
            rel="noopener noreferrer"
            onClick={onLinkClick}
          >
            {actionText}
          </a>
          <a
            className={substrateNotNeeded === '1' ? styles['c-filters-brand-logo'] : styles['c-filters-brand-logo-bg']}
            href={url}
            rel="noopener noreferrer"
            role="img"
            target="_blank"
            onClick={onLinkClick}
          >
            <img src={logoImageUrl} alt="logo" />
          </a>
          <div className={styles['c-filters-brand-left']}>
            <a
              className={styles['c-filters-brand-link']}
              href={url}
              rel="noopener noreferrer"
              role="button"
              target="_blank"
              onClick={onLinkClick}
            >
              <h3 className={styles['c-filters-brand-title']}>{name}</h3>
              <p className={styles['c-filters-brand-text']}>{info}</p>
            </a>
            <div>
              <Link
                href={url}
                className={styles['c-filters-brand-button']}
                rel="noopener noreferrer"
                target="_blank"
                onClick={onLinkClick}
              >
                {buttonText}
              </Link>
              <span className={styles['c-filters-brand-tel']}>{phone}</span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles['marquee']}>
        <Marquee text={note} />
      </div>
    </>
  ) : (
    <div />
  );
};
